import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { getBonuses } from '@/store/bonuses/actions';
import { selectLocale } from '@/store/selectors/commonSelectors';

export const useBonusesLoader = () => {
  const dispatch = useDispatch();
  const locale = useSelector(selectLocale);

  useEffect(() => {
    if (locale) {
      dispatch(getBonuses());
    }
  }, [locale]);
};
